import React from "react";
import classes from './ServicesInventionsDocumet.module.scss'
import Document from "../../../../components/Document";
export default function ServicesInventionsDocumet() {
    return(
        <Document/>

    )
    
}